var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#D0D0C8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 20C28 15.6 24.4 12 20 12C15.6 12 12 15.6 12 20C12 24 14.9 27.3 18.7 27.9V22.3H16.7V20H18.7V18.2C18.7 16.2 19.9 15.1 21.7 15.1C22.6 15.1 23.5 15.3 23.5 15.3V17.3H22.5C21.5 17.3 21.2 17.9 21.2 18.5V20H23.4L23 22.3H21.1V28C25.1 27.4 28 24 28 20Z",
    fill: "#181A1B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFb);
export default __webpack_public_path__ + "static/media/fb.b42879009df92b9499f3932adaab466b.svg";
export { ForwardRef as ReactComponent };